import { render } from "./CheckboxField.vue?vue&type=template&id=ed37227c&scoped=true"
import script from "./CheckboxField.vue?vue&type=script&lang=js"
export * from "./CheckboxField.vue?vue&type=script&lang=js"

import "./CheckboxField.vue?vue&type=style&index=0&id=ed37227c&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed37227c"]])

export default __exports__